import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu } from '@mui/material'

import { useMenu } from 'hooks/useMenu'
import { DownloadItem } from './components/DownloadItem'

import type { CellContext } from '@tanstack/react-table'
import type { BuildOrderForTable } from 'features/history/pages/BuildsPage/hooks/useGetBuildOrders'

type Props = CellContext<BuildOrderForTable, unknown>

export const ActionsCell = ({
  row: {
    original: { configurationUrl, id },
  },
}: Props): React.JSX.Element => {
  const { anchor, close, isOpen, open } = useMenu()

  if (!configurationUrl) {
    return <></>
  }

  return (
    <>
      <IconButton onClick={open}>
        <MoreVert data-cy='more-vert-icon' />
      </IconButton>

      <Menu
        anchorEl={anchor}
        onClose={close}
        open={isOpen}
      >
        <DownloadItem {...{ configurationUrl, id, onDownloadEnd: close }} />
      </Menu>
    </>
  )
}
